import ActionTypes from 'app/auth/ActionTypes';
import reducer from 'app/auth/reducer';

export default {
  reducers: {
    auth: reducer,
  },
  actionTypes: ActionTypes,
};
